<template>
  <div class="icon-wrapper" @click="openAnnouncement">
    <svg
      fill="#ffffff"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 239.563 239.563"
      style="enable-background:new 0 0 239.563 239.563;"
      xml:space="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M146.962,36.978h-1.953L85.568,69.611H42.605C19.113,69.611,0,88.723,0,112.216c0,21.012,15.301,38.474,35.334,41.943
              L21.56,202.585h47.523l13.584-47.756h2.901l59.443,32.628h1.953c12.585,0,22.826-10.239,22.826-22.826V59.803
              C169.787,47.219,159.546,36.978,146.962,36.978z M57.592,187.366H41.71l8.352-29.364h15.882L57.592,187.366z M109.459,150.581
              l-19.988-10.972H42.605c-15.103,0-27.388-12.29-27.388-27.393c0-15.103,12.285-27.388,27.388-27.388h46.866l19.988-10.974
              V150.581z M154.57,164.631c0,3.637-2.567,6.683-5.978,7.431l-23.916-13.127V65.502l23.916-13.13
              c3.414,0.748,5.978,3.797,5.978,7.434V164.631z"
            />
            <path
              d="M198.989,79.377L188.106,90.26c5.623,7.789,8.976,17.32,8.976,27.637c0,10.32-3.353,19.851-8.976,27.637l10.883,10.883
              c8.326-10.629,13.31-24,13.31-38.52C212.299,103.377,207.315,90.007,198.989,79.377z"
            />
            <path
              d="M218.358,60.009l-10.794,10.794c10.482,12.856,16.782,29.252,16.782,47.094c0,17.845-6.3,34.238-16.782,47.094
              l10.794,10.794c13.216-15.648,21.205-35.849,21.205-57.888S231.574,75.657,218.358,60.009z"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import Semver from "semver";
import Package from "../../../../../package.json";

export default {
  name: "AnnouncementIcon",
  methods: {
    openAnnouncement() {
      this.$modal.changeToComponent(this.$modal.modalType.Announcement);
    },
    getCookie(name) {
      const token = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
      return token ? token[2] : null;
    }
  },
  mounted() {
    // const version = this.getCookie("version");
    // if (!version || Semver.satisfies(version, `<${Package.version}`)) {
    //   this.$modal.changeToComponent(this.$modal.modalType.Announcement);
    // }
    // document.cookie = `version=${Package.version}`;
  }
};
</script>

<style lang="scss" scoped>
.icon-wrapper {
  width: 24px;
  height: 24px;

  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/sidebar/AnnouncementIcon.vue